<template>
  <el-dialog title="详情" :visible.sync="detailDialogVisible" width="800px" center>
    <div class="detail">
      <div class="baseInfo" v-loading="detailDialogLoad">
        <div class="baseInfoTitle">
          <div class="line" />
          <span>基础信息</span>
        </div>
        <div class="baseInfoContent">
          <el-form :model="detailData" label-position="left">
            <el-row>
              <el-col :span="12">
                <el-form-item label="运输方式:">
                  <span>{{ detailData.transportType | transportTypeFormat}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="路线:">
                  <span>{{ detailData.startAddressName }} - {{detailData.endAddressName}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="委托商:">
                  <span>{{ detailData.customerName }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="baseInfoTitle">
          <div class="line" />
          <span>价格信息</span>
        </div>
        <div class="baseInfoContent">
          <el-form label-position="left">
            <el-row>
              <el-col :span="24">
                <el-form-item label="品牌:">
                  <span>{{ detailData.brandName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="费用类型:">
                  <span>{{ getPriceType(detailData.priceType) }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="单价:">
                  <span>{{ detailData.price }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开始时间:">
                  <span>{{ detailData.startDate }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="结束时间:">
                  <span>{{ detailData.endDate }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注:">
                  <span>{{ detailData.remake }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="detailData.operateRecordList" border :header-cell-style="{ background: '#E8E8E8', color: '#3B3B3B', height: '35px' }">
              <el-table-column prop="createTime" label="操作时间" align="center" width="160px" />
              <el-table-column prop="operateType" label="操作类型" align="center" />
              <el-table-column prop="operationName" label="操作人" align="center" />
              <el-table-column prop="remark" label="备注" align="center" />
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {planConsignorDetail} from "@/service/financial";
import {paramCategoryPageList} from "@/service/basicfile";

export default {
  data(){
    return{
      detailDialogLoad: false,
      detailDialogVisible: false,
      detailData: {},
      operationData: [],
      priceTypeOption: []
    }
  },
  filters: {
    transportTypeFormat(value) {
      switch (value) {
        case 1:
          return '公路';
        case 2:
          return '水路';
        case 3:
          return '联运';
      }
    },
  },
  mounted() {
    this.getPriceTypeOption()
  },
  methods:{
    dialogOpen(row){
      this.detailDialogVisible = true;
      this.getDetail(row.id)
    },
   async getDetail(id){
     const {
       status,
       message,
       data,
     } = await planConsignorDetail({id:id})
     if (status !== 0) return this.$message.error(message);
     this.detailData = data
   },
    async getPriceTypeOption() {
      const {status, message, data} = await paramCategoryPageList({
        value: '',
        status: '',
        rows: 9999,
        Page: 1,
        classaName: '',
        states: '',
        paramId: '658625de271048b78be6f1f569211d14',
      });
      this.priceTypeOption = data.records
    },
    getPriceType(val) {
      for (let i = 0; i < this.priceTypeOption.length; i++) {
        if (this.priceTypeOption[i].classbName == val) {
          return this.priceTypeOption[i].classaName;
        }
      }
    },
  }
}
</script>


<style scoped lang="scss">

</style>
